import { createAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  isOnline: false,
  activeClients: [] as any[],
  metadata: {} as any,
};

export const setPodAction = createAction<Object>('SET_POD');

const podSlice = createSlice({
  name: 'pod',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setPodAction, (state, action) => {
      for (let prop in state) {
        delete state[prop];
      }
      Object.assign(state, action.payload);
    });
  },
});

export default podSlice;
